import React from 'react';

import styles from './HeaderHero.module.scss';
import Image from 'next/image';

import { Small } from 'components/text';
import Link from 'next/link';
import Container from 'components/container';
import { HeaderHeroProps } from './types';

const HeaderHero: React.FC<HeaderHeroProps> = ({
  hotelPageLink,
  headerImage,
}) => {
  const { image, description, caption } = headerImage;

  return (
    <Container as="header" className={styles.wrapper}>
      <Container className={styles.imageContainer}>
        <Link href={hotelPageLink} passHref>
          <a target="_blank" rel="noopener noreferrer">
            <Image
              src={image}
              layout="fill"
              objectPosition="center"
              objectFit="cover"
              alt={description}
              sizes="200vw"
            />
          </a>
        </Link>
      </Container>
      {caption && (
        <div className={styles.caption}>
          <Small color="grey-dark">{caption}</Small>
        </div>
      )}
    </Container>
  );
};

export default HeaderHero;
